// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.105.4/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/fonts/Zepto_Norms_Normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/assets/fonts/Zepto_Norms_Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/assets/fonts/Zepto_Norms_DemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/assets/fonts/Zepto_Norms_Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/assets/fonts/Zepto_Norms_ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Zepto Norms';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format('woff2');
  font-weight: 450;
}

@font-face {
  font-family: 'Zepto Norms';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format('woff2');
  font-weight: 500;
}

@font-face {
  font-family: 'Zepto Norms';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    format('woff2');
  font-weight: 600;
}

@font-face {
  font-family: 'Zepto Norms';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
    format('woff2');
  font-weight: 700;
}

@font-face {
  font-family: 'Zepto Norms';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
    format('woff2');
  font-weight: 800;
}

:root {
  --font-zepto-norms: 'Zepto Norms';
}
`, "",{"version":3,"sources":["webpack://./apps/hrms/src/fonts.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B;mBACiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B;mBACiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B;mBACiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B;mBACiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B;mBACiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["@font-face {\n  font-family: 'Zepto Norms';\n  src: url('../../../public/assets/fonts/Zepto_Norms_Normal.woff2')\n    format('woff2');\n  font-weight: 450;\n}\n\n@font-face {\n  font-family: 'Zepto Norms';\n  src: url('../../../public/assets/fonts/Zepto_Norms_Medium.woff2')\n    format('woff2');\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: 'Zepto Norms';\n  src: url('../../../public/assets/fonts/Zepto_Norms_DemiBold.woff2')\n    format('woff2');\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: 'Zepto Norms';\n  src: url('../../../public/assets/fonts/Zepto_Norms_Bold.woff2')\n    format('woff2');\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: 'Zepto Norms';\n  src: url('../../../public/assets/fonts/Zepto_Norms_ExtraBold.woff2')\n    format('woff2');\n  font-weight: 800;\n}\n\n:root {\n  --font-zepto-norms: 'Zepto Norms';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
